var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invite-detail" }, [
    _c("div", { staticClass: "__second-title" }, [
      _vm._v(_vm._s(_vm.$t("inviteMining.myInviteIncome")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "describe" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$t("tradeMining.inviteCount")) +
          ": " +
          _vm._s(_vm.inviter ? _vm.inviter.inviteCount || 0 : 0) +
          "\n    "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }